import { FETCH_QUERY_KEYS } from "src/queries/consts";
import { CACHE_DURATION } from "@consts";
import { queryClient } from "src/lib/react-query/queryClient";
import speechService from "src/queries/services/speech";
import assistantsService from "src/queries/services/assistants";
import { assistantLanguagesQuery } from "src/queries/hooks/assistants";
import { getLanguages } from "src/components/collections/helpers";

const SPEECH_CACHE_DURATION = 5 * 60 * 1000;

export const fetchVoiceSettings = async ({ accountId, assistantId, systemMode, signal }) => await queryClient.fetchQuery({
  queryKey: [FETCH_QUERY_KEYS.CHANNEL_SETTINGS, accountId, assistantId, systemMode],
  queryFn: () => assistantsService.fetchChannelSettings({ accountId, assistantId, signal }),
  staleTime: CACHE_DURATION.ONE_MINUTE,
  gcTime: CACHE_DURATION.ONE_MINUTE
});

export const fetchAssistantLanguages = async ({ accountId, assistantId }) => {
  const languages = await queryClient.fetchQuery(assistantLanguagesQuery({ accountId, assistantId }));

  return { live: getLanguages(languages?.active), draft: getLanguages(languages?.draft) };
};

export const fetchSpeechAudio = async ({ text, voiceNames, language, speakingRate, isAdmin, signal, systemMode, pronunciationData }) => {
  const audioBlob = await queryClient.fetchQuery({
    queryKey: [FETCH_QUERY_KEYS.GENERATE_SPEECH, text, language, systemMode, pronunciationData?.pronunciation ?? null],
    queryFn: () => speechService.generateSpeech({ text, voiceNames, language, speakingRate, isAdmin, pronunciationData, signal }),
    staleTime: SPEECH_CACHE_DURATION,
    gcTime: SPEECH_CACHE_DURATION
  });

  return audioBlob;
};

export const invalidateSpeechCache = (text) => {
  if (text) {
    queryClient.invalidateQueries({ queryKey: [FETCH_QUERY_KEYS.GENERATE_SPEECH, text] });
  } else {
    queryClient.invalidateQueries({ queryKey: [FETCH_QUERY_KEYS.GENERATE_SPEECH] });
  }
};

